import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import Toolbar from '@material-ui/core/Toolbar'

class TableTitle extends React.Component {
  render() {
    const { classes, header, withBottomBorder } = this.props

    return (
      <Toolbar
        className={classNames(classes.titleRoot)}
        style={{
          borderBottom: withBottomBorder
            ? '1px solid rgba(224, 224, 224, 1)'
            : 'transparent'
        }}
      >
        <div className={classes.title}>
          <p variant={'title'} id={'tableTitle'}>
            {header}
          </p>
        </div>
        <div className={classes.spacer} />
      </Toolbar>
    )
  }
}

TableTitle.propTypes = {
  classes: PropTypes.object.isRequired
}

export { TableTitle }



// WEBPACK FOOTER //
// ./src/components/common/TableTitle.js